import { render } from "./Signpage.vue?vue&type=template&id=4be5ea2f&scoped=true&ts=true"
import script from "./Signpage.vue?vue&type=script&lang=ts"
export * from "./Signpage.vue?vue&type=script&lang=ts"

import "./Signpage.vue?vue&type=style&index=0&id=4be5ea2f&lang=css"
import "./Signpage.vue?vue&type=style&index=1&id=4be5ea2f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be5ea2f"]])

export default __exports__